module.exports = __webpack_public_path__ + "media/4x3/th-76fca72f.svg";